/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Typography } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import React, { ReactNode } from 'react';
import { enterpriseColors } from '../../style/colors';

const styles = StyleSheet.create({
  wrapper: {
    ...Typography.Roboto(),
    fontWeight: Typography.MEDIUM,
    paddingTop: 32,
    paddingBottom: 16,
    fontSize: 24,
  },
  line: {
    display: 'block',
    width: 40,
    height: 12,
    borderBottom: `4px solid ${enterpriseColors.PRIMARY_500}`,
  },
});

export namespace TabContentTitle {
  export interface Props {
    children: ReactNode;
  }
}

/** Title for tab in room detail page */
export const TabContentTitle: React.FC<TabContentTitle.Props> = ({ children }) => {
  return (
    <div className={css(styles.wrapper)}>
      {children}
      <div className={css(styles.line)} />
    </div>
  );
};
